import React, {useState} from 'react';
import {CardElement, useElements, useStripe} from '@stripe/react-stripe-js';
import axios from "axios";
import './css/common.css';
import { getUserAccessToken } from "../../../Redux/actions/user";
import { addNotification } from "../../../Utilities/notifications";
import {updateProfile} from "../../../Redux/actions/user"
import phoneNumbers from "../../../Utilities/phoneNumbers";
import loader from "../../../Assets/loaderTransaparent.gif"
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'



const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#000',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      opacity: '0.8',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#000',
      },
      '::placeholder': {
        color: 'rgba(0,0,0,0.5)',
      },
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ffc7ee',
    },
  },
};

const CardField = ({onChange}) => (  
  <div className="FormRow">
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

const Field = ({
  label,
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <label htmlFor={id} className="FormRowLabel">
      {label}
    </label>
    <input
      className="FormRowInput"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({processing, error, children, disabled}) => (
  <button
    className={`SubmitButton ${error ? 'SubmitButton--error' : ''}`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? 'Processing...' : children}
  </button>
);

const CheckoutForm = (props) => {  
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [cardValid,setCardValid]=useState(null)
  // const [paymentMethod, setPaymentMethod] = useState(null);
  const [billingDetails, setBillingDetails] = useState({
    email: props.user.email?props.user.email:"",
    phone: props.user.contactNumber?props.user.contactNumber:"",
    name: props.user.name?props.user.name:"",
  });
    let [ loading, setLoading] = useState(false)
    let [err,setErr] = useState(false)

const handleChange = async(phn,obj) => {
  let result = phoneNumbers.filter(i => i.countryCode === obj.countryCode) ;      
      let format=phn.replace(/[^\w\s]/gi, '')
      let phnNumber=format.replace(/ /g,'')      
      err = phnNumber.length.toString() !== result[0].length? true : false
      setErr(err)      
      setBillingDetails({ ...billingDetails, phone: phn });
}

  const handleSubmit = async (event) => {
    // Block native form submission.
    if(loading) return    
    setLoading(true)
    event.preventDefault();
    if(cardValid){
      if(props.plan === 'na' || props.plan === undefined) {
        alert("Please select a plan to subscribe")
        setLoading(false)
        return
      }
      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }
      // Get a reference to a mounted CardElement. Elements knows how
      // to find your CardElement because there can only ever be one of
      // each type of element.
      const cardElement = elements.getElement(CardElement);
      // Use your card Element with other Stripe.js APIs
      const card_token = await stripe.createToken(cardElement);
      let token = await getUserAccessToken();
      // let obj2= await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/csrftoken`)
      let headers = {
          headers: {
              'Authorization': `Bearer ${token}`,
              // "csrfToken":obj2.data.csrfToken,
              "X-Frame-Options":"sameorigin",
              "strict-transport-security": "max-age=31536000; includeSubDomains",
              "X-XSS-Protection":"1; mode=block",
              "x-content-type-options":"nosniff",
              "X-Download-Options":"noopen",
              "Content-Security-Policy":"policy"            }
      }
      let payload = {
              "name" : billingDetails.name,
              "email" : billingDetails.email,
              "phone" : billingDetails.phone,
              "description" : `created through API ${new Date()}`,
              "plan" : props.plan,
              "mode":"dev",
              "card_details" : card_token.token
            }  
            try{          
      let obj= await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/tf_payments/register_customer`,payload,headers)           
      if(obj.status === 200){
        setLoading(false)
        if(props.upgrade){
          let payload = props.user
          payload['subscription_id'] = 1
          let data = await updateProfile(payload, props.user);
          if(data.status === 204){
            addNotification({
              title: "Techforce.ai",
              message: "Congratulations! You are now subscribed to Standard E-Worker Machine",
              type: "success"
            });
          }
        }
        props.show_success_page()
      }
      }
      catch(err){
        addNotification({
          title: "Techforce.ai",
          message: "Payment has been failed",
          type: "danger"
        })
        setLoading(false)

      }
  }else{    
    setCardValid(false)
    setLoading(false)
  }
  }
  return  (
    

      <form className="Form" onSubmit={handleSubmit}>
        {
          cardValid != null && cardValid === false ? <div className="alert alert-danger" role="alert">
            Please Fillout All The Fields With Valid Data
            </div> :""
        }
        <fieldset className="FormGroup">
          <Field
            label="Name"
            id="name"
            type="text"
            placeholder="Jane Doe"
            required
            autoComplete="name"
            value={billingDetails.name}
            onChange={(e) => {
              setBillingDetails({...billingDetails, name: e.target.value});
            }}
          />
          <Field
            label="Email"
            id="email"
            type="email"
            placeholder="janedoe@gmail.com"
            required
            autoComplete="email"
            value={billingDetails.email}
            onChange={(e) => {
              setBillingDetails({...billingDetails, email: e.target.value});
            }}
          />
         <Field label="Phone" 
         id="phone"/>
          <div className="billing">
          <ReactPhoneInput
                inputExtraProps={{
                  name: "phone",
                  required: true,
                  autoFocus: true
                }}
                required
                country={"in"}
                onChange={handleChange}
                value={billingDetails.phone ? billingDetails.phone : ""}
                />
              {err > 0 && 
              <span className='error'>"Please enter valid number"</span>}
              </div>
        </fieldset>
        <fieldset className="FormGroup FormCard">
          <CardField
            required
            name="card"
            onChange={(e) => {              
              setError(e.complete);              
              setCardComplete(e.complete);
              setCardValid(true)
            }}
          />
        </fieldset>
        <button className="billing_button" processing={processing} error={error} disabled={!loading && !stripe }>          {
            loading? <img src={loader} height="100%" alt="..."
             /> : "Subscribe"
            }
        </button>
      </form>
  );
};


export default CheckoutForm;
